import api from '@/libs/axiosInstance';
import type { ApiResponse, BrandSignupInvitationDetails } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

const fetchBrandSignupInvitationDetails = async (
  token: string
): Promise<BrandSignupInvitationDetails> => {
  const response = await api.get<ApiResponse<BrandSignupInvitationDetails>>(
    `/brand-signup/invitations/${token}/details`
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || 'Failed to fetch brand signup invitation details');
};

export const useBrandSignupInvitationDetails = (
  token: string | null
): UseQueryResult<BrandSignupInvitationDetails, Error> => {
  return useQuery<BrandSignupInvitationDetails, Error>({
    queryKey: ['brand-signup', 'invitation-details', token],
    queryFn: () => fetchBrandSignupInvitationDetails(token!),
    enabled: !!token,
    retry: false,
  });
};
